import { action, computed, observable } from 'mobx';
import { uniq } from 'lodash';
interface Value {
  name: string;
  cnName: string;
  courseSeriesCnName: string;
  items: any;
}

class BreadcrumbStore {
  @observable public value: Value = {
    name: '',
    cnName: '',
    courseSeriesCnName: '',
    items: [],
  };

  get urlPools(): string[] {
    return nx.get(nx.$storage.session, 'breadcrumb.items', []);
  }

  @computed public get params() {
    return nx.hashlize();
  }

  @action
  public set(inPath: string, inValue: any) {
    nx.set(this.value, inPath, inValue);
  }

  @action
  public popUrl() {
    const urls = this.urlPools;
    urls.unshift(location.href);
    nx.$storage.session = { 'breadcrumb.items': uniq(urls) };
  }
}

export default new BreadcrumbStore();
